<template lang='pug'>
  #Footer.mb-3
    p.p-0.m-0.text-center 呷胖胖 所有圖片皆來自於網路
    p.p-0.m-0.text-center Copyright © 2021
</template>

<style lang="scss" scoped>
@import "../assets/scss/all.scss";
#Footer {
  width: 100%;
  height: auto;
  // background: #c5c4a6;
  // box-shadow: 0 0 5px #c5c4a6;
  background: #fff;
  position: relative;
  // color: #fff;
  color: #c5c4a6;
  font-weight: 300;
  line-height: 2rem;
  font-size: 0.8rem;
}
</style>

<script>
export default {
  name: 'Footer'
}
</script>
